import { Appointment, SUBJECT_KEYS } from "@elixir/types";
import { ReactComponent as AbhaCustomIcon } from "../../../../assets/icons/custom/abha.svg";
import { openCreateAbhaFlow } from "../../../../utils/bridges/methods";
import { getAclViewClassName } from "@elixir/utils";

const AbhaId = ({
  apt,
  className = "dr-col-span-2",
}: {
  apt: Appointment;
  className?: string;
}) => {
  const { abha } = apt;
  const isAbhaCreated = !!abha?.id
  return (
    <div
      onClick={() => {
        if (isAbhaCreated) return;
        openCreateAbhaFlow(apt);
      }}
      className={`BodyBody2Regular dr-py-7 dr-px-8 dr-border-1 dr-border-darwin-touch-neutral-100 space-x-8 dr-rounded-4  flex items-center dr-h-32 dr-cursor-pointer ${
        !isAbhaCreated
          ? "dr-text-darwin-touch-neutral-1000"
          : "dr-text-darwin-touch-primary-primary"
      } ${className} ${getAclViewClassName(SUBJECT_KEYS.ABHA)}`}
    >
      <AbhaCustomIcon className="dr-min-w-13 dr-w-13" />

      <span className="dr-line-clamp-1">
        {isAbhaCreated ? abha?.id : "Create Abha"}
      </span>
    </div>
  );
};

export default AbhaId;
